import { Link } from 'react-router-dom'
import { Mail } from 'lucide-react'

export default function AboutPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="text-3xl font-bold text-secondary-900 mb-8">About LinkZon</h1>

      <div className="prose prose-secondary max-w-none space-y-6 text-secondary-700 leading-relaxed">
        <p>
          LinkZon is a curated digital platform connecting expertise in Health and Biomedical Sciences across institutions and borders.
        </p>
        <p>
          We enable students, researchers, clinicians, and health professionals to offer and access structured academic engagement — including mentorship, lectures, advisory sessions, and specialized consulting.
        </p>
        <p>
          Our mission is to increase access to high-quality expertise globally while maintaining professional standards, fair compensation, and institutional credibility.
        </p>

        <h2 className="text-xl font-semibold text-secondary-900 mt-10 mb-4">How It Works</h2>
        <p>LinkZon operates as a two-sided platform:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            <strong>Experts</strong> create verified profiles showcasing their academic background, skills, and availability.
          </li>
          <li>
            <strong>Individuals and organizations</strong> discover and book expertise through structured matching.
          </li>
        </ul>
        <p>
          We are building a global network grounded in precision, professionalism, and equity in education.
        </p>

        <hr className="my-10 border-secondary-200" />

        <h2 className="text-xl font-semibold text-secondary-900 mb-4">Legal Information</h2>
        <div className="bg-secondary-50 rounded-xl border border-secondary-200 p-6 space-y-2 text-sm">
          <p><span className="font-medium text-secondary-900">Business Name:</span> Linkzon</p>
          <p><span className="font-medium text-secondary-900">Business Type:</span> Sole proprietorship (enskild näringsverksamhet)</p>
          <p><span className="font-medium text-secondary-900">Registered in:</span> Sweden</p>
          <p><span className="font-medium text-secondary-900">Registered address:</span> Kindstugatan 16, 111 31 Stockholm</p>
          <p>
            <span className="font-medium text-secondary-900">Contact email:</span>{' '}
            <a href="mailto:connect@linkzon.se" className="text-accent-600 hover:text-accent-700">connect@linkzon.se</a>
          </p>
        </div>

        <div className="mt-6 p-4 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-800">
          <p>
            LinkZon functions solely as a digital intermediary platform. The platform does not provide medical advice, healthcare services, or licensed clinical treatment. All services are provided independently by Experts listed on the platform.
          </p>
        </div>

        <div className="mt-10 flex items-center gap-6 text-sm">
          <Link to="/terms" className="text-accent-600 hover:text-accent-700 font-medium">Terms of Service</Link>
          <Link to="/privacy" className="text-accent-600 hover:text-accent-700 font-medium">Privacy Policy</Link>
          <a href="mailto:connect@linkzon.se" className="text-accent-600 hover:text-accent-700 font-medium inline-flex items-center gap-1">
            <Mail className="h-4 w-4" />
            Contact Us
          </a>
        </div>
      </div>
    </div>
  )
}
